<template>
	<AtomInputUtilWrapper
		:title="title"
		:description="description"
		:is-required="isRequired"
		:error-messages="errorMessages"
	>
		<textarea
			v-model="model"
			rows="4"
			:name="name"
			:class="[
				'w-full rounded border py-3.5 shadow-sm px-3 border-gray-300',
				'focus:outline-0 focus:ring-2 focus:ring-offset-2 focus:ring-purple-500',
				'text-gray-900 placeholder:text-gray-400 text-functional-size-md',
				errorMessages.length > 0
					? 'ring-2 ring-offset-2 ring-red-500'
					: '',
			]"
			:data-test-error="errorMessages.length > 0 ? true : undefined"
			:placeholder="placeholder"
			:disabled="isDisabled"
			:required="isRequired"
			:readonly="isReadonly"
			@focusout="(e) => validate((e.target as HTMLInputElement).value)"
		/>
	</AtomInputUtilWrapper>
</template>

<script setup lang="ts">
import type { InputPropDefaultsType } from '#base/core/types/InputPropDefaultsType';
import validatorStringInput from '#base/helpers/validators/validatorStringInput';

const props = defineProps<
	InputPropDefaultsType & {
		title: string;
		description?: string;
	}
>();

const model = defineModel<string>();

const errorMessages = ref<string[]>([]);

function validate(value: string) {
	errorMessages.value = [
		...validatorStringInput(value, {
			isRequired: props.isRequired,
			isDisabled: props.isDisabled,
			fieldName: props.title,
		}),
	];
}
</script>
